import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { PopupLayoutComponent } from "@app/admin/confirmation-popup/popup-layout/popup-layout.component";

@Component({
    selector: "app-manual-expense-restriction-popup",
    templateUrl: "./manual-expense-restriction-popup.component.html",
    styleUrls: ["./manual-expense-restriction-popup.component.scss"],
    standalone: false
})
export class ManualExpenseRestrictionPopup implements OnInit {
  constructor(private router: Router) { }

  @ViewChild("modal") modal: PopupLayoutComponent;

  ngOnInit(): void { }

  closeModal() {
    this.modal.close();
  }
}
